import React from 'react';
import DevicesView from './DevicesView';

const DevicesPage: React.FC = () => <DevicesView />;

export default DevicesPage;
